export const withDelay = async <T>(result: T, delay: number): Promise<T> => {
  return await new Promise<T>((resolve) => {
    setTimeout(resolve, delay, result)
  })
}
